import { render, staticRenderFns } from "./disapprove.vue?vue&type=template&id=0edf3ff0&scoped=true"
import script from "./disapprove.vue?vue&type=script&lang=ts"
export * from "./disapprove.vue?vue&type=script&lang=ts"
import style0 from "./disapprove.vue?vue&type=style&index=0&id=0edf3ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf3ff0",
  null
  
)

export default component.exports